(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vape-category-slider"] && !window.DesignMode) return;
  try {
    
  

  // document.addEventListener("DOMContentLoaded", function () {
  //   var $slider = $('.vape-category-slider');
  //   if ($slider.length > 0) {
  //     $slider.slick({
  //       slidesToShow: $(window).width() < 768 ? 1 : 3,
  //       slidesToScroll: 1,
  //       infinite: true,
  //       arrows: false,
  //       dots: false,
  //       speed: 300,
  //       autoplay: true,
  //       responsive: [
  //         {
  //           breakpoint: 768,
  //           settings: {
  //             slidesToShow: 1
  //           }
  //         }
  //       ]
  //     });
  //   }
  // });


  } catch(e) { console.error(e); }
})();
})();
